import { Reducer, combineReducers } from 'redux'
import { TrainerUIState, TrainerActionTypes } from './types'
import { ITrainerProfile } from '../interface'

// Type-safe initialState!
const initialState: TrainerUIState = {
    loading: false,
    processing: false,
    processState : 0,  // 0: Initial, 1: Success, 2: Failed
    selected: undefined,
    errors: undefined,
    isConflict : false,
    totDoc : 0
}

const ui: Reducer<TrainerUIState> = (state = initialState, action) => {
    switch (action.type) {
        // List
        case TrainerActionTypes.LIST_REQUEST: {
            return { ...state, loading: true, isConflict : false, processState: 0, searchParams : action.payload }
        }
        case TrainerActionTypes.LIST_SUCCESS: {
            return { ...state, loading: false, isConflict : false, processState: 1, totDoc: action.payload.totalDoc }
        }
        case TrainerActionTypes.LIST_ERROR: {
            return { ...state, loading: false, isConflict : false, processState: 2, errors: action.payload.errors }
        }
        case TrainerActionTypes.LIST_CLEAR: {
            return { ...state, loading: false, isConflict : false, processState: 0, totDoc : 0, searchParams : undefined, errors : undefined }
        }
        // Select
        case TrainerActionTypes.SELECT: {
            return { ...state, loading: true, processState: 0, selected: action.payload };
        }
        case TrainerActionTypes.SELECTED: {
            return { ...state, loading: false, processState: 0 };
        }
        case TrainerActionTypes.CLEAR_SELECTED: {
            return { ...state, loading: false, processState: 0, selected: undefined };
        }
        // Create
        case TrainerActionTypes.CREATE_REQUEST: {
            return { ...state, processing: true, processState: 0 };
        }
        case TrainerActionTypes.CREATE_SUCCESS: {
            return { ...state, processing: false, processState: 1, selected : action.payload.id };
        }
        case TrainerActionTypes.CREATE_ERROR: {
            return { ...state, processing: false, processState: 2, selected: undefined, errors: action.payload.errors }
        }
        // Update
        case TrainerActionTypes.UPDATE_REQUEST: {
            return { ...state, processing: true, processState: 0, isConflict : false };
        }
        case TrainerActionTypes.UPDATE_SUCCESS: {
            return { ...state, processing: false, processState: 1, isConflict : false };
        }
        case TrainerActionTypes.UPDATE_ERROR: {
            return { ...state, processing: false, processState: 2, isConflict : action.payload.isConflict, errors: action.payload.errors }
        }
        // Delete
        case TrainerActionTypes.DELETE_REQUEST: {
            return { ...state, processing: true, processState: 0 };
        }
        case TrainerActionTypes.DELETE_SUCCESS: {
            return { ...state, processing: false, processState: 3};
        }
        case TrainerActionTypes.DELETE_ERROR: {
            return { ...state, processing: false, processState: 4, errors: action.payload.errors }
        }
        default: {
            return state
        }
    }
}


const byId: Reducer<{}> = (state = {}, action) => {
    switch (action.type) {
        case TrainerActionTypes.LIST_SUCCESS: {
            var _temp: any = {};
            if (action.payload.isSuccess && action.payload.totalDoc > 0){  
                if (action.payload.offset == 0){ 
                    // Reset initial search
                    action.payload.doc.forEach((item: ITrainerProfile) => {
                        _temp[item.id] = item;
                    });
                    return _temp;
                }
                else
                {
                    // Combine if load more
                    const currentStateList:any = {...state};
                    action.payload.doc.forEach((item: ITrainerProfile) => {
                        if(currentStateList[item.id] === undefined)
                        {
                            _temp[item.id] = item;
                        }
                    });
                    return { ...state, ..._temp };
                }
            }else{
                return _temp;
            }
        }
        case TrainerActionTypes.CREATE_SUCCESS:
        case TrainerActionTypes.UPDATE_SUCCESS: {
            return {
                ...state, [action.payload.id]: action.payload
            }
        }
        case TrainerActionTypes.DELETE_SUCCESS:
            var _temp: any = state;
            delete _temp[action.payload];
            return _temp;

        default: {
            return state
        }
    }
}

const allIds: Reducer<string[]> = (state = [], action) => {
    switch (action.type) {
        case TrainerActionTypes.LIST_SUCCESS: {
            if (action.payload.totalDoc > 0){  
                if (action.payload.offset ==0){
                    var results:any =[];
                    results = action.payload.doc.map((item: ITrainerProfile) => item.id);
                    return results;
                }else{
                    const results = [...state];
                    action.payload.doc.forEach((item: ITrainerProfile) => {
                        if(results.some((s)=>s === item.id) === false)
                        {
                            results.push(item.id);
                        }
                    });
                    return results;
                }
            }else{
                var results:any =[];
                return results;
            }
        }
        case TrainerActionTypes.CREATE_SUCCESS: {
            // return [
            //     ...state, action.payload.id
            // ]
            var _temp: any = state;
            _temp.splice(0, 0, action.payload.id);
            return _temp;
        }
        case TrainerActionTypes.DELETE_SUCCESS:{
            return state.filter(d => d !== action.payload);
        }
        default: {
            return state
        }
    }
}

// //
// const byCategory: Reducer<{}> = (state = {}, action) => {
//     switch (action.type) {
//         case UserActionTypes.FETCH_SUCCESS: {
            
//             //action.payload.map((item: User) => item.id)
//             const result:any[] = action.payload.reduce(function (r:any, a:any) {
//                 r[a.Category] = r[a.Category] || [];
//                 r[a.Category].push(a.id);
//                 return r;
//             }, Object.create(null));
//             return result;
//         }
//         case UserActionTypes.ADD_SUCCESS: {
//             const result:any = {...state};
//             result[action.payload.Category].push(action.payload.id)
            
//             return result;
//         }
//         default: {
//             return state
//         }
//     }
// }

// const Category: Reducer<string[]> = (state = [], action) => {
//     switch (action.type) {
//         case UserActionTypes.FETCH_SUCCESS:
//         case UserActionTypes.ADD_SUCCESS:
//         {
//             const results =[...state];
//             action.payload.forEach((item: User) => {
//                 if(results.some((s)=>s === item.Category)===false)
//                 {
//                     results.push(item.Category);
//                 }
//             });
            
//             return results;
//         }
//         default: {
//             return state
//         }
//     }
// }

// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
const TrainersReducer = combineReducers({
    ui,
    byId,
    allIds,
    // byCategory,
    // Category
})
export default TrainersReducer

